class LapsPoignetSelector extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('.laps-poignet__button');
    this.mediaItems = this.querySelectorAll('.laps-poignet__media-item');

    // Pause all videos except the active one
    this.mediaItems.forEach((item, index) => {
      const video = item.querySelector('video');
      if (video && index !== 0) {
        video.pause();
      }
    });

    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const index = parseInt(button.getAttribute('data-index'), 10);
        this.switchMedia(index);
      });
    });
  }

  switchMedia(index) {
    this.buttons.forEach((btn) => btn.classList.remove('laps-poignet__button--active'));
    this.mediaItems.forEach((item) => {
      item.classList.remove('laps-poignet__media-item--active');
      const video = item.querySelector('video');
      if (video) video.pause();
    });

    const activeButton = this.querySelector(`.laps-poignet__button[data-index="${index}"]`);
    const activeMedia = this.querySelector(`.laps-poignet__media-item[data-index="${index}"]`);

    if (activeButton) activeButton.classList.add('laps-poignet__button--active');
    if (activeMedia) {
      activeMedia.classList.add('laps-poignet__media-item--active');
      const video = activeMedia.querySelector('video');
      if (video) video.play();
    }
  }
}

customElements.define('laps-poignet-selector', LapsPoignetSelector);
